import { render, staticRenderFns } from "./RegistrationHeader.vue?vue&type=template&id=4e1acc4c&"
import script from "./RegistrationHeader.vue?vue&type=script&lang=js&"
export * from "./RegistrationHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports